// extracted by mini-css-extract-plugin
export var askAiIcon = "_k7-9";
export var container = "_k7-0";
export var groupSeparator = "_k7-a";
export var highlight = "_k7-4";
export var resultIcon = "_k7-5";
export var resultItem = "_k7-7";
export var resultSubtitle = "_k7-3";
export var resultTitle = "_k7-2";
export var resultsList = "_k7-1";
export var searchGroup = "_k7-6";
export var selected = "_k7-8";